import { BackgroundGif, HeroSection, Navigation } from "@/components/landing/marketing-sections";
import "./index.css";

/*
 * Minimal Tilee marketing homepage at the root route.
 * Inputs: none.
 * Outputs: Navigation, hero, and primary buy action.
 */
export const App = () => {
  return (
    <>
      <BackgroundGif />
      <main className="relative z-20 min-h-screen text-foreground">
        <Navigation />
        <HeroSection />
      </main>
    </>
  );
};

export default App;
